"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _ramda = require("ramda");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _handlers = require("../../../../../helpers/handlers");
var _RenderWhen = _interopRequireDefault(require("../../../../RenderWhen"));
var _Button = _interopRequireWildcard(require("../../../Button"));
var _Input = _interopRequireDefault(require("../../../Input"));
var _Label = _interopRequireDefault(require("../../../Label"));
var _arrow = _interopRequireDefault(require("./arrow.svg"));
var _clear = _interopRequireDefault(require("./clear.svg"));
var _styles = _interopRequireDefault(require("./styles"));
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var StyledWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    :active,\n    :focus,\n    :hover {\n        border-color: ", ";\n    }\n"])), function (props) {
  return props.theme.primaryColor;
});
var mapperWithIndex = (0, _ramda.addIndex)(_ramda.map);
var MultipleControl = function MultipleControl(_ref) {
  var className = _ref.className,
    isOpen = _ref.isOpen,
    _ref$isError = _ref.isError,
    isError = _ref$isError === void 0 ? false : _ref$isError,
    items = _ref.items,
    label = _ref.label,
    searchInputRef = _ref.searchInputRef,
    searchString = _ref.searchString,
    _ref$withArrow = _ref.withArrow,
    withArrow = _ref$withArrow === void 0 ? false : _ref$withArrow,
    onClick = _ref.onClick,
    onRemove = _ref.onRemove,
    onSearch = _ref.onSearch;
  var control = /*#__PURE__*/_react.default.createElement(StyledWrapper, {
    className: (0, _classnames2.default)(_styles.default.wrapper, className, _defineProperty(_defineProperty({}, _styles.default.active, isOpen), _styles.default.error, isError)),
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.field
  }, /*#__PURE__*/_react.default.createElement(_RenderWhen.default, null, /*#__PURE__*/_react.default.createElement(_RenderWhen.default.If, {
    isTrue: !(0, _ramda.isEmpty)(items)
  }, mapperWithIndex(function (item, index) {
    var _item$icon;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: _styles.default.buttonWrapper,
      key: index
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: _styles.default.fieldButton,
      contentClassName: _styles.default.buttonContent
    }, item.content, /*#__PURE__*/_react.default.createElement(_RenderWhen.default, {
      limit: 2
    }, /*#__PURE__*/_react.default.createElement(_RenderWhen.default.If, {
      isTrue: Boolean(item.icon)
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _styles.default.transportIcon,
      dangerouslySetInnerHTML: {
        __html: (_item$icon = item.icon) === null || _item$icon === void 0 ? void 0 : _item$icon.element
      }
    })))), /*#__PURE__*/_react.default.createElement(_RenderWhen.default, {
      limit: 2
    }, /*#__PURE__*/_react.default.createElement(_RenderWhen.default.If, {
      isTrue: Boolean(onRemove)
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: _styles.default.clearIcon,
      icon: _clear.default,
      theme: _Button.THEMES.TRANSPARENT,
      onClick: onRemove ? (0, _handlers.handleWith)(_handlers.prevent, _handlers.stop, function () {
        return onRemove(item);
      }) : undefined
    }))));
  }, items))), isOpen && onSearch && /*#__PURE__*/_react.default.createElement(_Input.default, {
    autoFocus: true,
    autoWidth: true,
    ref: searchInputRef,
    value: searchString,
    onChange: onSearch,
    onClick: _handlers.stop
  })), withArrow && /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.arrowIcon,
    dangerouslySetInnerHTML: {
      __html: _arrow.default
    }
  }));
  return label ? /*#__PURE__*/_react.default.createElement(_Label.default, {
    clickable: false,
    text: label
  }, control) : control;
};
MultipleControl.propTypes = {
  className: _propTypes.default.string,
  isOpen: _propTypes.default.bool.isRequired,
  isError: _propTypes.default.bool,
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    content: _propTypes.default.any.isRequired,
    icon: _propTypes.default.shape({
      element: _propTypes.default.string.isRequired,
      title: _propTypes.default.string
    }),
    value: _propTypes.default.any.isRequired
  })),
  label: _propTypes.default.string,
  searchInputRef: _propTypes.default.func,
  searchString: _propTypes.default.string,
  withArrow: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  onRemove: _propTypes.default.func,
  onSearch: _propTypes.default.func
};
var _default = exports.default = (0, _react.memo)(MultipleControl);